<template>
  <div class="sidebar">
    <!-- <div class="logo"><img src="../../../static/img/logo.png" width="100%" /></div> -->
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" unique-opened router>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i class="el-icon-n" :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <el-menu-item v-for="(subItem,i) in item.subs" class="sub_item" :key="i" :index="subItem.index">{{ subItem.title }}
            </el-menu-item>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i class="el-icon-n el-icon" :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from '../common/bus'
import auth from '@/utils/auth'
import _ from 'lodash'

export default {
  data() {
    return {
      collapse: false,
      items: []
    }
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace('/', '')
    },
    myItems() {
      return this.items.filter(o => {
        _.find(menus, predicate, fromIndex)
      })
    }
  },
  created() {
    this.setItems()
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('collapse', msg => {
      this.collapse = msg
    })
  },
  methods: {
    setItems() {
      this.items = [
        {
          icon: 'el-icon-s-order',
          index: 'order',
          title: '投标订单'
        },
        {
          icon: 'el-icon-s-order',
          index: 'hetonglvyue',
          title: '合同履约订单'
        },
        {
          icon: 'el-icon-s-order',
          index: 'yufukuan',
          title: '预付款订单'
        },
        {
          icon: 'el-icon-s-order',
          index: 'nongmingong',
          title: '农民工工资支付订单'
        },
        {
          icon: 'el-icon-s-order',
          index: 'gongchengkuan',
          title: '工程款支付订单'
        }
        // {
        //   icon: 'el-icon-g-zhuye',
        //   index: 'dashboard',
        //   title: '系统主页'
        // },
        // {
        //   icon: 'el-icon-g-huoban',
        //   index: 'zhishuhuoban',
        //   title: '直属伙伴'
        // },
        // {
        //   icon: 'el-icon-g-baohan',
        //   index: 'baohanshezhi',
        //   title: '保函设置'
        // },
        // {
        //   icon: 'el-icon-g-yanzheng',
        //   index: 'baodanyanzhen',
        //   title: '保单验真'
        // },
        // {
        //   icon: 'el-icon-g-settings',
        //   index: 'settings',
        //   title: '系统设置'
        // }
      ]
    }
  }
}
</script>

<style scoped>
.el-menu {
  border: 0;
}

.sidebar {
  display: block;
  position: absolute;
  top: 87px;
  bottom: 0px;
  overflow-y: scroll;
  left: 0;
  background-color: #fdf9f1;
  border-right: 1px solid #ccc;
  /* background: #29325e; */
}

/* .sidebar .logo {
  width: 180px;
  height: 56px;
  margin: 10px auto;
} */
.sidebar .logo {
  width: 180px;
  height: 36px;
  margin: 10px auto;
}
.sidebar .logo img {
  vertical-align: top;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
  background-color: #fdf9f1;
  /* background: #29325e; */
}

.sidebar > ul {
  height: 100%;
}

.sidebar > ul > li {padding: 0;
  color: #201702;
}
.sidebar > ul > li:hover {
  background-color: #e3a720;
  /* background: #18215e; */
}
.sub_item {
  position: relative;
  margin-bottom: 0;
  background-color: #f0f0f0;
}

.sidebar .sub_item {
  padding-left: 50px;
}

.sub_item:before {
  content: '';
  position: absolute;
  top: 50%;
  left: 30px;
  width: 8px;
  height: 1px;
  background: #aaa;
}

.popperclass {
  border: solid 1px red;
}

.el-menu-item [class^='el-icon-'],
.el-submenu [class^='el-icon-'] {
  font-size: 24px;
  margin-right: 8px;
  color: #aaa;
}

.el-menu-item.is-active,
.sidebar .el-submenu__title:hover,
.sidebar .el-menu-item.is-active {
  border-left: 6px solid #f56c6c;
  background-color: #f8c756;
  /* background-color: #fff; */
}

.el-menu-item.is-active {
  font-weight: bold;
  color: #29325e;
}

.el-menu-item.is-active [class^='el-icon-'],
.el-submenu.is-active [class^='el-icon-'] {
  color: #29325e;
}
.el-menu-item, .el-submenu__title {
    height: 46px;
    line-height: 46px;
    position: relative;
    -webkit-box-sizing: border-box;
    white-space: nowrap;
    list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Sidebar.vue